import styled, { css } from 'styled-components';

import { MenuItem, TextButton, mediaMixin } from '@zillow/constellation';

export const StyledDisabledMenuItem = styled(MenuItem)`
    && {
        cursor: default;
        opacity: .5;

        &:hover, &:focus {
            background: none;
        }
    }
`;

export const StyledTextButton = styled(TextButton)`
    font-size: 12px;
    font-weight: 400;

    ${mediaMixin('lg', css`
        font-size: 14px;
        font-weight: 600;
    `)}

    /* 1024 */
    ${mediaMixin('xl', css`
        font-size: ${({ size }) => (size === 'lg' ? '16px' : '14px')};
    `)}

    &:hover {
        text-decoration: none;
    }
`;
